import deepmerge from 'deepmerge'
import { init } from './state'

export default {
  /**
   * ユーザステート一式を設定する
   *
   * @param {State} state
   * @param {Object} user ユーザ情報
   */
  setData (state, user) {
    const data = deepmerge(init, user)
    for (const k in data) {
      state[k] = data[k]
    }
  },
  /**
   * ライセンス情報を設定する
   *
   * @param {State} state
   * @param {Object} license ライセンス情報
   */
  setLicense (state, license) {
    for (const key in license) {
      switch (key) {
        case 'acquire':
          state.licenseAcquire = license[key]
          break
        case 'expire':
          state.licenseExpire = license[key]
          break
        case 'types':
          state.licenseAT = Boolean(Number(license[key][14]))
          break
        default:
          break
      }
    }
  }
}
